import * as Sentry from "@sentry/react";

export function logProjectEvent(projectId: string, event: string, data: any) {
  Sentry.logger.info(`project-${projectId}-${event}-${Date.now()}`, data);
}

export function logException(error: any, data: any) {
  console.error(error, data);
  Sentry.captureException(error, {
    extra: data,
  });
}

/**
 * Debug logging utility that only logs when NOT in production environment.
 * Use this for development/debugging console logs that should never appear in production.
 *
 * @example
 * debugLog('[DEBUG]', 'Store initialized', { state });
 * debugLog(`[DEBUG ${new Date().toISOString()}] Message`, data);
 */
export function debugLog(...args: any[]): void {
  if (import.meta.env.VITE_PROD === "false") {
    console.log(...args);
  }
}
